import axios from '../../app/axios';
import Cookies from 'js-cookie';
import Vue from 'vue';
import Events from '@/app/events.js'

axios.defaults.withCredentials = true;


const state = {
  user:{
    id: null,
    name: null,
    surname: null,
    loggedIn:false,
    email: '',
    password: '',
    keepLoggedIn: false,
    created_at: null,
  },
  auth:{
     loggedIn:false,
  }
  
}

const actions = {

  /**
   * 
   * Attempt to login
   * 
   * @param {State} State
   * @param {Commit} commit 
   * @param {Object} payload 
   * 
   * @return { Object } user
   */
 async authenticationAction({
    commit,
    state,
  }, payload) {

        return axios.post(`${process.env.VUE_APP_API_URL}/user/${process.env.VUE_APP_LOGIN_API}`, payload).then( response => {

          if (response.status == 200) {

            commit('updateUserState',response.data.data)
            return response;

          }

          throw new Error(response);

        }).catch( exception => { 
          
          throw exception 

        })

  },

  /**
   * 
   * Check auth status
   * 
   * @param {State} State
   * @param {Commit} commit 
   * @param {Object} payload 
   * 
   * @return { Object } user
   */
 async authenticationCheck({commit,state}) {

        return axios.get(`${process.env.VUE_APP_API_URL}/user/auth-check`).then( response => {
          
          commit('setUserAuthState',response.data.data)
        
        }).catch( exception => { 
          
          throw exception 

        })

  },

}

const mutations = {

  /**
   * Update state values
   * @param {Object} state 
   * @param {Object} payload 
   */
  updateUserState(state, payload = {}) {

    return Object.keys(state).forEach(key => {
      if (payload.hasOwnProperty(key) && state.hasOwnProperty(key)) {
        state.user[key] = payload[key];
      }
    });

  },

  /**
   * Update state values
   * @param {Object} state 
   * @param {Object} payload 
   */
  setUserAuthState(state, payload = {}) {

    state.auth.loggedIn = payload
    Events.$emit('auth-success')
    
  },


}

const getters = {

  /**
   * User Current state
   * 
   * @param {VUEX} state 
   */
  isAuthed(state) {
    return state.auth.loggedIn 
  },

  /**
   * User Current state
   * 
   * @param {VUEX} state 
   */
  auth(state) {
    return state
  }

}

export default {
  state,
  mutations,
  actions,
  getters
}